import posthog from 'posthog-js'

posthog.init('phc_dFHzdPzFCOafb8c56CSsCMqQV0yhEntHgnMPSpmx1bn', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'always',
    autocapture: true
})

export default posthog 